import { Shape, Keyword, URL } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { either } = Parser;
const parse = either(URL.parse, either(Shape.parse, Keyword.parse("none")));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), parse, (value) => value);
//# sourceMappingURL=clip-path.js.map